import React from 'react';
import styles from './HighlightCard.module.scss';
import { HighlightCardConfig } from '../../../../Models/Widget';
import { TextOverflowTooltip } from '../../../TextOverflowTooltip/TextOverflowTooltip';

export interface HighlightCardProps extends HighlightCardConfig {}

export const HighlightCard = ({
  label,
  value
}: HighlightCardProps): React.ReactElement<HighlightCardProps> => {
  const strValue = `${Math.floor(value)}`;
  const noData = label.toLocaleLowerCase() === 'no data' || value === 0;
  const displayLabel = noData ? 'No Data' : label;

  return (
    <div className={styles.highlightCard}>
      <div className={styles.data}>
        <TextOverflowTooltip title={displayLabel}>
          <span className={styles.value}>{displayLabel}</span>
        </TextOverflowTooltip>

        {!noData && <div className={styles.chip}>{strValue}</div>}
      </div>
    </div>
  );
};
